export enum NegativadoFinanceiroPorExtenso {
  Sim = 'Sim',
  Nao = 'Não'
}
